<template>
<v-col cols="3" class="d-flex justify-begin mb-2">
      <v-btn class="mx-2 gris_medio" @click="exportToCSV">
                   {{$t('general.exportar')}}<span class="material-symbols-outlined">arrow_outward</span>
                </v-btn>
                <v-btn  class="mx-2 gris_medio" @click="importFromCSV">
                 <span class="material-symbols-outlined">arrow_insert</span>  {{$t('general.importar')}}
                  <input
                    type="file"
                    accept=".csv"
                    ref="fileInput"
                    style="display: none;"
                    @change="handleUpload"
                  />
                </v-btn>
              
              </v-col>
    <div><br>
      <div class="scroll-container">
      <table>
       
        <thead>
          <tr>
            <th class="encabezado columna_sticky">{{ labels.nombre }}</th>
            <th class="encabezado"> 
               <v-tooltip location="right"> 
                  <template v-slot:activator="{ props }">
                    {{ labels_recortado.potencia_gas_maxima }}
                    <v-icon v-bind="props">   mdi-help-circle-outline</v-icon>
                  </template>
                  <span>{{ labels.potencia_gas_maxima }}</span>
                </v-tooltip>
            </th> 
          
            <th class="encabezado"> 
               <v-tooltip location="right"> 
                  <template v-slot:activator="{ props }">
                    {{ labels_recortado.potencia_gas_minima }}
                    <v-icon v-bind="props">   mdi-help-circle-outline</v-icon>
                  </template>
                  <span>{{ labels.potencia_gas_minima }}</span>
                </v-tooltip>
            </th> 
            <th class="encabezado"> 
               <v-tooltip location="right"> 
                  <template v-slot:activator="{ props }">
                    {{ labels_recortado.potencia_vapor_maxima }}
                    <v-icon v-bind="props">   mdi-help-circle-outline</v-icon>
                  </template>
                  <span>{{ labels.potencia_vapor_maxima }}</span>
                </v-tooltip>
            </th> 
            
            <th class="encabezado"> 
               <v-tooltip location="right"> 
                  <template v-slot:activator="{ props }">
                    {{ labels_recortado.rendimiento_vapor_gas }}
                    <v-icon v-bind="props">   mdi-help-circle-outline</v-icon>
                  </template>
                  <span>{{ labels.rendimiento_vapor_gas }}</span>
                </v-tooltip>
            </th> 
            <th class="encabezado"> 
               <v-tooltip location="right"> 
                  <template v-slot:activator="{ props }">
                    {{ labels_recortado.coeficiente_emisiones_CO2 }}
                    <v-icon v-bind="props">   mdi-help-circle-outline</v-icon>
                  </template>
                  <span>{{ labels.coeficiente_emisiones_CO2 }}</span>
                </v-tooltip>
            </th> 
            <th class="encabezado"> 
               <v-tooltip location="right"> 
                  <template v-slot:activator="{ props }">
                    {{ labels_recortado.estado_inicial_equipo }}
                    <v-icon v-bind="props">   mdi-help-circle-outline</v-icon>
                  </template>
                  <span>{{ labels.estado_inicial_equipo }}</span>
                </v-tooltip>
            </th> 
            
          </tr>
        </thead>
        <tbody>
          <tr v-for="(caldera, index) in calderas" :key="index" class="tabla-hover">
            <td class="primera_columna columna_sticky">{{ caldera.nombre }}</td>
            <td>
              <input
                type="number"
                step="0.01"
                v-model.number=caldera.potencia_gas_maxima
                @change="updateCalculatedFields(index)"
              />
            </td>
            <td>
              <input
                type="number"
                step="0.01"
                v-model.number= caldera.potencia_gas_minima
                @input="emitChanges"
              />
            </td>
            <td class="valor_fijo">
              <input
                type="number"
                v-model.number=caldera.potencia_vapor_maxima
                disabled
              />
            </td>
            <td>
              <input
                type="number"
                step="0.01"
                v-model.number=caldera.rendimiento_vapor_gas
                @change="updateCalculatedFields(index)"
              />
            </td>
            <td>
              <input
                type="number"
                step="0.01"
                v-model.number=caldera.coeficiente_emisiones_CO2
                @input="emitChanges"
              />
            </td>
            <td>
            <select v-model="caldera.estado_inicial_equipo" @change="emitChanges"
            :class="{ 'motor_apagado': caldera.estado_inicial_equipo === 'Parado', 'motor_encendido': caldera.estado_inicial_equipo === 'Encendido' }"
            >
                <option value="Parado">Parado</option>
                <option value="Encendido">Encendido</option>
            </select>
            </td>
          </tr>
        </tbody>
      </table>
      </div>
    </div>
  </template>
  
  <script>
  import Swal from 'sweetalert2';

const HEADERS_OFICIALES_CALDERAS = [
  "Nombre",
  "Potencia gas máxima",
  "Potencia gas mínima",
  "Potencia vapor máxima",
  "Rendimiento vapor/gas",
  "Coeficiente emisiones CO2",
  "Estado inicial equipo"
];
  export default {
    props: {
      modelValue: {
        type: Array,
        default: () => [], // Array vacío por defecto
      },
    },
    data() {
      return {
        calderas: Array.isArray(this.modelValue) ? [...this.modelValue] : [],
        labels: {
          nombre: this.$t("planta.planta_calderas_gas"),
          potencia_gas_maxima: this.$t("planta.calderas_gas.potencia_gas_maxima"),
          potencia_gas_minima: this.$t("planta.calderas_gas.potencia_gas_minima"),
          potencia_vapor_maxima: this.$t("planta.calderas_gas.potencia_vapor_maxima"),
          rendimiento_vapor_gas: this.$t("planta.calderas_gas.rendimiento_vapor_gas"),
          coeficiente_emisiones_CO2: this.$t("planta.calderas_gas.coeficiente_emisiones_CO2"),
          estado_inicial_equipo: this.$t("planta.calderas_gas.estado_inicial_equipo"),
        },
        labels_recortado: {
          nombre: this.$t("planta.planta_calderas_gas"),
          potencia_gas_maxima: this.$t("planta.calderas_gas_corto.potencia_gas_maxima"),
          potencia_gas_minima: this.$t("planta.calderas_gas_corto.potencia_gas_minima"),
          potencia_vapor_maxima: this.$t("planta.calderas_gas_corto.potencia_vapor_maxima"),
          rendimiento_vapor_gas: this.$t("planta.calderas_gas_corto.rendimiento_vapor_gas"),
          coeficiente_emisiones_CO2: this.$t("planta.calderas_gas_corto.coeficiente_emisiones_CO2"),
          estado_inicial_equipo: this.$t("planta.calderas_gas_corto.estado_inicial_equipo"),
        },
      };
    },
    watch: {
      modelValue: {
        handler(newValue) {
          this.calderas = Array.isArray(newValue) ? [...newValue] : [];
        },
        deep: true,
      },
      "potencia_vapor_maxima"() {
      this.updateCalculatedFields();
    },
    },
    methods: {
      toCsvDecimalComma(v, fixed = null) {
        if (v === null || v === undefined || v === '') return '';
        const n = Number(v);
        if (Number.isNaN(n)) return '';
        const s = fixed != null ? n.toFixed(fixed) : String(n);
      
        return s.replace('.', ',');
      },
      emitChanges() {
        this.$emit("update:modelValue", this.calderas);
      },
       /* Formatea los números a dos decimales para la vista sin convertirlos en string
    formatDecimal(value) {
      return value ? Number(value).toFixed(2) : "0.00";
  },

  // Actualiza el valor de la caldera y se asegura de que es un número
    updateCaldera(index, key, value) {
      const newValue = parseFloat(value).toFixed(2); // Redondea a dos decimales

      // Asegurar reactividad en Vue 3 sin perder el tipo numérico
      this.calderas = this.calderas.map((caldera, i) => 
        i === index ? { ...caldera, [key]: Number(newValue) } : caldera
      );

      this.$emit("update:modelValue", [...this.calderas]);
    },*/

  // Calcula el valor de potencia_vapor_maxima con formato adecuado
    updateCalculatedFields(index) {
        const caldera = this.calderas[index];
        if (caldera) {
          const newPotenciaVapor = parseFloat(
            (caldera.potencia_gas_maxima * caldera.rendimiento_vapor_gas) || 0
          ).toFixed(2);

          // Asegurar que el valor sea numérico y no string
          this.calderas = this.calderas.map((caldera, i) =>
            i === index ? { ...caldera, potencia_vapor_maxima: Number(newPotenciaVapor) } : caldera
          );

          this.$emit("update:modelValue", [...this.calderas]);
        }
      },
      exportToCSV() {
  try {
    const headers = HEADERS_OFICIALES_CALDERAS;

    const rows = this.calderas.map(c => [
      c.nombre ?? '',
      this.toCsvDecimalComma(c.potencia_gas_maxima),
      this.toCsvDecimalComma(c.potencia_gas_minima),
      this.toCsvDecimalComma(c.potencia_vapor_maxima), // derivada, pero la exportamos
      this.toCsvDecimalComma(c.rendimiento_vapor_gas),
      this.toCsvDecimalComma(c.coeficiente_emisiones_CO2),
      (c.estado_inicial_equipo === 'Encendido' || c.estado_inicial_equipo === 'Parado') ? c.estado_inicial_equipo : ''
    ].join(';'));

    const csvContent = [headers.join(';'), ...rows].join('\n');
    const blob = new Blob(["\uFEFF" + csvContent], { type: "text/csv;charset=utf-8;" });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "calderas_vapor.csv";
    link.click();
    URL.revokeObjectURL(link.href);

    Swal.fire({ icon: 'success', title: 'Exportación correcta', timer: 1600, showConfirmButton: false });
  } catch (e) {
    Swal.fire({ icon: 'error', title: 'Error al exportar', text: e?.message || 'Revisa los datos.' });
  }
},

      importFromCSV() {
        this.$refs.fileInput.click();
      },

     handleUpload(event) {
  const file = event.target.files[0];
  if (!file) return;

  if (!/\.csv$/i.test(file.name)) {
    Swal.fire({ icon: 'error', title: 'Formato no válido', text: 'Solo se admiten archivos .csv.' });
    event.target.value = '';
    return;
  }

  const reader = new FileReader();
  reader.onload = (e) => {
    try {
      const content = e.target.result;
      const lines = content.replace(/\r\n/g, '\n').split('\n').filter(Boolean);
      if (lines.length < 2) throw new Error('El CSV está vacío.');

      // ====== Validación de CABECERAS ======
      let headers = lines[0]
  .split(';')
  .map((h, i) => (i === 0 ? String(h).replace(/^\uFEFF/, '') : String(h)).trim());

// 1) faltantes / extras
const faltantes = HEADERS_OFICIALES_CALDERAS.filter(h => !headers.includes(h));
const extrasRaw = headers.filter(h => !HEADERS_OFICIALES_CALDERAS.includes(h));

// limpiar valores vacíos/espacios 
const extras = extrasRaw.map(x => String(x).trim()).filter(Boolean);

// 2) desordenadas solo si no hay faltantes ni extras visibles
let desordenadas = [];
if (faltantes.length === 0 && extras.length === 0) {
  HEADERS_OFICIALES_CALDERAS.forEach((h, i) => {
    if (headers[i] !== h) desordenadas.push(`${h} (posición esperada ${i + 1})`);
  });
}

// 3) renderizar solo secciones con elementos 
const seccion = (titulo, arr) => {
  const items = (arr || []).map(x => String(x).trim()).filter(Boolean);
  return items.length
    ? `<h4 style="margin:6px 0 2px 0;">${titulo}</h4>
       <ul style="margin:0 0 8px 18px; padding:0;">${items.map(x => `<li>${x}</li>`).join('')}</ul>`
    : '';
};

if (faltantes.length || extras.length || desordenadas.length) {
  const html =
    `<div style="text-align:left;">
       <p>El CSV no respeta la <b>plantilla oficial</b> (encabezados y orden).</p>
       ${seccion('❌ Faltan', faltantes)}
       ${seccion('⚠️ Sobran', extras)}
       ${seccion('🔄 Desordenadas', desordenadas)}
       <p style="margin-top:6px;"><small>
         Consejo: exporta la plantilla oficial y copia tus datos respetando los encabezados y su orden.
       </small></p>
     </div>`;
  Swal.fire({ icon: 'error', title: 'Encabezados incorrectos', html, width: 800 });
  event.target.value = '';
  return;
}
      // ====== Fin validación de CABECERAS ======

      // Índices según plantilla 
      const IDX = {
        nombre: 0,
        pGasMax: 1,                 // Potencia gas máxima
        pGasMin: 2,                 // Potencia gas mínima
        pVaporMax: 3,               // Potencia vapor máxima
        rendimiento: 4,             // Rendimiento vapor/gas
        coefCO2: 5,                 // Coeficiente emisiones CO2
        estado: 6                   // Estado inicial equipo
      };

      // Helpers
      const raw = (arr, i) => String(arr[i] ?? '').trim();
      const parseNumberStrict = (value) => {
        const s = String(value ?? '').trim();
        if (s === '') return { ok: false, num: NaN }; // vacío => inválido
        const n = this.parseNumber(s);
        return { ok: Number.isFinite(n), num: n };
      };

      // Trackers de errores
      const faltasPorCol = {
        [headers[IDX.nombre]]: [],
        [headers[IDX.pGasMax]]: [],
        [headers[IDX.pGasMin]]: [],
        [headers[IDX.pVaporMax]]: [],
        [headers[IDX.rendimiento]]: [],
        [headers[IDX.coefCO2]]: [],
        [headers[IDX.estado]]: [],
      };
      const negativosPorCol = {
        [headers[IDX.pGasMax]]: [],
        [headers[IDX.pGasMin]]: [],
        [headers[IDX.pVaporMax]]: [],
        [headers[IDX.rendimiento]]: [],
        [headers[IDX.coefCO2]]: [],
      };
      const inconsistencias = [];

      const nuevos = [];

      for (let i = 1; i < lines.length; i++) {
        const cols = lines[i].split(';');
        if (cols.every(c => c.trim() === '')) continue; 
        if (cols.length !== HEADERS_OFICIALES_CALDERAS.length) {
          throw new Error(`Fila ${i + 1}: número de columnas inválido (${cols.length}).`);
        }

        const row = i + 1;

        // Lectura 
        const nombre = raw(cols, IDX.nombre);
        const pGasMaxRaw = raw(cols, IDX.pGasMax);
        const pGasMinRaw = raw(cols, IDX.pGasMin);
        const pVaporMaxRaw = raw(cols, IDX.pVaporMax);
        const rendimientoRaw = raw(cols, IDX.rendimiento);
        const coefCO2Raw = raw(cols, IDX.coefCO2);
        const estado = raw(cols, IDX.estado);

        // Requeridos vacíos
        if (!nombre) faltasPorCol[headers[IDX.nombre]].push(row);
        if (!pGasMaxRaw) faltasPorCol[headers[IDX.pGasMax]].push(row);
        if (!pGasMinRaw) faltasPorCol[headers[IDX.pGasMin]].push(row);
        if (!pVaporMaxRaw) faltasPorCol[headers[IDX.pVaporMax]].push(row);
        if (!rendimientoRaw) faltasPorCol[headers[IDX.rendimiento]].push(row);
        if (!coefCO2Raw) faltasPorCol[headers[IDX.coefCO2]].push(row);
        if (!estado) faltasPorCol[headers[IDX.estado]].push(row);

        // Parseos estrictos
        const { ok: okMax, num: pGasMax } = parseNumberStrict(pGasMaxRaw);
        const { ok: okMin, num: pGasMin } = parseNumberStrict(pGasMinRaw);
        const { ok: okRend, num: rendimiento } = parseNumberStrict(rendimientoRaw);
        const { ok: okVap, num: pVaporMaxCsv } = parseNumberStrict(pVaporMaxRaw);
        const { ok: okCO2, num: coefCO2 } = parseNumberStrict(coefCO2Raw);

        if (pGasMaxRaw && !okMax) faltasPorCol[headers[IDX.pGasMax]].push(row);
        if (pGasMinRaw && !okMin) faltasPorCol[headers[IDX.pGasMin]].push(row);
        if (pVaporMaxRaw && !okVap) faltasPorCol[headers[IDX.pVaporMax]].push(row);
        if (rendimientoRaw && !okRend) faltasPorCol[headers[IDX.rendimiento]].push(row);
        if (coefCO2Raw && !okCO2) faltasPorCol[headers[IDX.coefCO2]].push(row);

        // Negativos NO permitidos
        if (okMax && pGasMax < 0) negativosPorCol[headers[IDX.pGasMax]].push(row);
        if (okMin && pGasMin < 0) negativosPorCol[headers[IDX.pGasMin]].push(row);
        if (okVap && pVaporMaxCsv < 0) negativosPorCol[headers[IDX.pVaporMax]].push(row);
        if (okRend && rendimiento < 0) negativosPorCol[headers[IDX.rendimiento]].push(row);
        if (okCO2 && coefCO2 < 0) negativosPorCol[headers[IDX.coefCO2]].push(row);

        // Coherencias
        if (okMax && okMin && pGasMin > pGasMax) {
          inconsistencias.push(`Fila ${row}: 'Potencia gas mínima' no puede superar a 'Potencia gas máxima'.`);
        }

        if (estado && estado !== 'Encendido' && estado !== 'Parado') {
          inconsistencias.push(`Fila ${row}: 'Estado inicial equipo' debe ser 'Encendido' o 'Parado'.`);
        }

        if (okMax && okRend && okVap) {
          const pVaporMaxCalc = Number((pGasMax * rendimiento).toFixed(2));
          if (Math.abs(pVaporMaxCsv - pVaporMaxCalc) > 0.01) {
            inconsistencias.push(
              `Fila ${row}: 'Potencia vapor máxima' debe ser 'Potencia gas máxima' × 'Rendimiento vapor/gas'. Valor esperado: ${pVaporMaxCalc}.`
            );
          }
        }

        // Guardamos
        nuevos.push({
          nombre,
          potencia_gas_maxima: okMax ? pGasMax : null,
          potencia_gas_minima: okMin ? pGasMin : null,
          potencia_vapor_maxima: okMax && okRend ? Number((pGasMax * rendimiento).toFixed(2)) : null,
          rendimiento_vapor_gas: okRend ? rendimiento : null,
          coeficiente_emisiones_CO2: okCO2 ? coefCO2 : null,
          estado_inicial_equipo: estado || null
        });
      }

      // Consolidar errores
      const colsFaltas = Object.entries(faltasPorCol).filter(([, arr]) => arr.length);
      const colsNeg = Object.entries(negativosPorCol).filter(([, arr]) => arr.length);

      if (colsFaltas.length || colsNeg.length || inconsistencias.length) {
        const bloques = [];
        if (colsFaltas.length) {
          const htmlF = colsFaltas.map(([col, arr]) =>
            `• <b>${col}</b>: líneas <b>${arr.slice(0, 12).join(', ')}${arr.length > 12 ? '…' : ''}</b>`
          ).join('<br>');
          bloques.push(`<h4 style="margin:8px 0 4px 0;">Faltan datos obligatorios</h4>${htmlF}`);
        }
        if (colsNeg.length) {
          const htmlN = colsNeg.map(([col, arr]) =>
            `• <b>${col}</b>: líneas <b>${arr.slice(0, 12).join(', ')}${arr.length > 12 ? '…' : ''}</b>`
          ).join('<br>');
          bloques.push(`<h4 style="margin:8px 0 4px 0;">Valores negativos no permitidos</h4>${htmlN}`);
        }
        if (inconsistencias.length) {
          bloques.push(
            `<h4 style="margin:8px 0 4px 0;">Inconsistencias</h4>
             <ul style="margin:0 0 8px 18px; padding:0;">${inconsistencias.map(m => `<li>${m}</li>`).join('')}</ul>`
          );
        }

        Swal.fire({
          icon: 'error',
          title: 'Errores en datos',
          html: `<div style="text-align:left; max-height:50vh; overflow:auto;">${bloques.join('<br>')}</div>`,
          width: 820
        });
        event.target.value = '';
        return; 
      }

      // Sin errores: aplicar
      this.calderas = nuevos;
      this.emitChanges();
      Swal.fire({ icon: 'success', title: 'Importación correcta', text: `${nuevos.length} registros importados.` });

    } catch (err) {
      Swal.fire({ icon: 'error', title: 'Error al importar', text: err?.message ?? 'Archivo no válido.' });
    } finally {
      event.target.value = ''; // limpia el input
    }
  };

  reader.readAsText(file, 'utf-8');
},


      parseNumber(value) {
      if (!value) return 0;

      
      value = value.trim();

      
      if (value.includes(',') && !value.includes('.')) {
        value = value.replace(/\./g, '');        
        value = value.replace(',', '.');          
      }

      
      else if (value.includes(',') && value.includes('.')) {
        
        if (value.lastIndexOf(',') > value.lastIndexOf('.')) {
          value = value.replace(/\./g, '');       
          value = value.replace(',', '.');      
        }
        
        else {
          value = value.replace(/,/g, '');        
        }
      }

      

      return parseFloat(value);
    },
    },
  };
  </script>
  
  <style scoped>
   .motor_apagado{
    color: #EA7550 !important;
    background-color: rgba(234, 117, 80, 0.15) !important;
  }

  .motor_encendido{
    background-color: rgba(148, 212, 137, 0.15);
    color: #94D489;

  }
  table {
    width: 100%;
    border-collapse: collapse;
    text-align: center;
    
  }
  thead {
    position: sticky;
    top: 0;
    background-color: white;
    z-index: 10;
  }
    /* Contenedor con scroll horizontal y vertical */
    .scroll-container {
    width: 100%;
    max-height: 500px; /* Altura máxima antes de que aparezca el scroll vertical */
    overflow-x: auto;
    overflow-y: auto;
    
     border-radius: 10px;
  }
  .table-header {
    font-size: 1.5em;
    font-weight: bold;
    text-align: center;
    margin-bottom: 10px;
    color: white;
    background-color: #006699;
  }


  .valor_fijo{
    background-color: white;
  }

  td {
    font-weight: bold;
    color: #686868;
    padding: 10px;
     border-top: 2px solid #D9D9D9;
    border-bottom: 2px solid #D9D9D9;
    background-color: white;
  }
  
  input[type="number"] {
    width: 100%;
    text-align: right;
    border: none;
    border-radius: 4px;
    color: #686868;
  }
  
  select {
    width: 100%;
    border: 1px solid #F2F2F2;
    border-radius: 4px;
    text-align: center;
    color: #686868;
  }
  
  input[disabled] {
    background-color: white;
    color: #686868;
    cursor: not-allowed;
  }
  </style>
  